import { Component, Injector, Input, Optional } from '@angular/core';

import { ProjectregelArtikelService } from 'src/app/core/service/projectregel-artikel.service';
import { ProjectregelArtikel } from 'src/app/core/dto/projectregel-artikel';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Projectregel } from 'src/app/core/dto/projectregel';

@Component({
    selector: 'c-i-j-borculo-projectregel-artikel-collection',
    templateUrl: './projectregel-artikel-collection.component.html'/*,
    styleUrls: ['./projectregel-artikel-collection.component.css'] */
})
export class ProjectregelArtikelCollectionComponent extends PagedCollectionComponent<ProjectregelArtikel> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<ProjectregelArtikel>([
        { colDef: 'artikel', prop: x => x.artikel.omschrijving1, searchable: SearchableType.String },
		{ colDef: 'aantal', prop: x => x.aantal, searchable: SearchableType.Number },
		{ colDef: 'aantal_Offerte', prop: x => x.aantal_Offerte, searchable: SearchableType.Number },
		{ colDef: 'aantal_Besteld', prop: x => x.aantal_Besteld, searchable: SearchableType.Number },
		{ colDef: 'aantal_Geleverd', prop: x => x.aantal_Geleverd, searchable: SearchableType.Number },
		{ colDef: 'prijs', prop: x => x.prijs, searchable: SearchableType.Number }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ProjectregelArtikelService, @Optional() protected filter: Filter<ProjectregelArtikel>, injector: Injector) {
        super('/projectregelArtikel/projectregelArtikel', injector, ProjectregelArtikel);

        this.initInput('projectregel', this.filterBuilder.equal(x => x.projectregel.id));
        this.orderBy = [-1];

        this.filter.onGetChipLabel(x => x.artikel.omschrijving1, () => 'Artikel');
        this.filter.onGetChipLabel(x => x.aantal, () => 'Aantal');
		this.filter.onGetChipLabel(x => x.aantal_Offerte, () => 'Offerte');
        this.filter.onGetChipLabel(x => x.aantal_Besteld, () => 'Besteld');
		this.filter.onGetChipLabel(x => x.aantal_Geleverd, () => 'Geleverd');		
        this.filter.onGetChipLabel(x => x.prijs, () => 'Prijs');
		
    }

    @Input() set projectregel(val: Projectregel) { this.handleInput('projectregel', val.id); }
    
	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on

		return super.displayColumn(colDef, ix);
	}
}